import { Box } from "@mui/material"
import { createURL_SSR, ROUTE } from "app-constants/routing"
import { ContentContainer } from "components/content-container"
import MainLayout from "components/main-layout"
import { Videos } from "components/videos/Videos"
import buildServerSidePage from "lib/build-server-side-page"
import buildServerSideProps from "lib/build-server-side-props"
import applyCache from "lib/mw/apply-cache"
import applyCurrentServerContext from "lib/mw/apply-current-server-context"
import applyNextSeo from "lib/mw/apply-next-seo"
import applyTitle from "lib/mw/apply-title"
import { Current } from "lib/use-current"
import ConventionTag from "models/convention-api/v1/ConventionTag"
import ConventionVideo from "models/convention-api/v1/ConventionVideo"
import React from "react"
import tryToGetAppLogo from "utils/tryToGetAppLogo"

export const getServerSideProps = buildServerSideProps(
  applyTitle("Videos"),
  applyCache(),
  applyCurrentServerContext(),
  [
    ConventionTag.applyAll("allTags", {}),
    ConventionVideo.applyMore("recentlyAddedVideos", {
      limit: 20,
      sort: "-created_at",
      includes: ["institution", "video_count"],
    }),
    ConventionTag.applyMore("shuffledTags", {
      limit: 10,
      sort: "shuffled_position",
      filter: {
        tagged: "video",
      },
    }),
    ConventionVideo.applyMore("featuredVideos", {
      limit: 20,
      includes: ["institution", "video_count"],
      filter: {
        featured: "true",
      },
    }),
  ],
  applyNextSeo((context) => ({
    openGraph: {
      title: context.props.current?.provider?.name + " - Videos",
      url: createURL_SSR(context, { path: ROUTE.VIDEOS }),
      type: "website",
      images: [tryToGetAppLogo(context.props.current)],
    },
  })),
)

interface VideosPageProps {
  allTags: ConventionTag[]
  shuffledTags: ConventionTag[]
  recentlyAddedVideos: ConventionVideo[]
  featuredVideos: ConventionVideo[]
  current: Current
}

export default buildServerSidePage(function VideosPage(props: VideosPageProps) {
  return (
    <Box sx={{ overflow: "hidden" }}>
      <MainLayout layout="macro">
        <ContentContainer>
          <Videos {...props} />
        </ContentContainer>
      </MainLayout>
    </Box>
  )
})
